console.log(window['runConfig']);

const { baseApi, baseRecursos,  protocolUrl, urlMath, urlSiicex, folderResource } = window['runConfig'];


export const API_URL = `${protocolUrl}://${baseApi}/api/`;
export const BASE_URL_RECURSOS = `${protocolUrl}://${baseRecursos}${folderResource}`;


export const BASE_URL_RUEDAS = `${protocolUrl}://${urlMath}/`;
export const BASE_URL_SIICEX = `${protocolUrl}://${urlSiicex}}/`;


export const CODIGO_ESTUDIOS = '681';
export const DATE_OPTIONS_SHORT = { year: 'numeric', month: 'numeric', day: 'numeric' };
export const OPTIONS_ACTIVE = ['INACTIVO', 'ACTIVO'];
